export function createSegFilterField(segments, selectedSegments) {
  let segFilter = []
  for(let item of selectedSegments) {
    for(let defaultSegment of segments) {
      if(item === defaultSegment.value && defaultSegment.hasOwnProperty('expression')) {
        segFilter.push(defaultSegment.expression)
      }
    }
  }

  return `concat_ws('|',${segFilter.join(',')})`
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataAgg/createSegFilterField.js